export default __webpack_public_path__ + "media/flavours/glitch/images/elephant_ui_disappointed-83980a5d0868aabbde510765f8a44a84.svg";